// extracted by mini-css-extract-plugin
export default {"new-excursion-button":"Excursions_new-excursion-button__gn5T3","tab":"Excursions_tab__IixQl","active":"Excursions_active__iGfu8"};